/* eslint-disable */

export const ScrollToUtils = {
    scrollToElement(horizontal = false) {
        setTimeout(() => {           
            if (window.innerWidth <= 1200 || horizontal) {
                const form = document.getElementById("scrollToForm");
                form.scrollIntoView({behavior: "smooth", block: "end"});;
            }
        }, 500);
    },
};


